import styled from 'styled-components';
import ClickOutside from 'library/components/click-outside';
import {
  InputRadioStyles,
  OptionContainerStyles,
} from 'library/components/dropdown/styles';
import Colors from 'library/constants/colors';
import { SearchContainerStyles } from 'library/components/search/styles';

export const StyledClickOutside = styled(ClickOutside)`
  display: inline-block;
`;

export const OptionContainer = styled.div`
  ${OptionContainerStyles};
  min-width: 280px;
  max-width: 350px;
  padding: 0 5px;
  width: auto;
  z-index: 21;
`;

export const OptionsList = styled.div`
  padding-left: 15px;
  padding-bottom: 4px;
  max-height: 400px;
  overflow-y: scroll;
  height: auto;
`;

export const SearchInputContainer = styled.div`
  ${SearchContainerStyles};
  height: 55px;
  margin-bottom: 4px;
  border-bottom: 1px solid ${Colors.shade06};
`;

export const InputCheckbox = styled.input`
  ${InputRadioStyles};

  + label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 20px;
    &:before {
      top: 10px;
      left: 0;
      width: 18px;
      height: 18px;
      border-radius: 1px;
    }

    &:after {
      top: 14px;
      left: 4px;
      width: 10px;
      height: 10px;
    }
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 126px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  height: calc(100vh - 126px);
`;
